import { initializeBraze } from '../lib/braze';
import { readMeta, readMetaBoolean } from '@/lib/page';

const brazeApiKey = readMeta('braze_api_key');
const brazeBaseUrl = readMeta('braze_base_url');
const brazeEnableLogging = readMetaBoolean('braze_enable_logging');
const accountId = readMeta('account', 'data-account');
const nonceScript = document.querySelector('script[nonce]');

initializeBraze(brazeApiKey, brazeBaseUrl, brazeEnableLogging, accountId, nonceScript);
